import { render, staticRenderFns } from "./rew.vue?vue&type=template&id=0ccdb950&"
import script from "./rew.vue?vue&type=script&lang=js&"
export * from "./rew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports